// extracted by mini-css-extract-plugin
module.exports = {"button":"TableButton_button_2p1Pe"};